export const url = process.env.REACT_APP_URL;
export const user_Token = localStorage.getItem("user_Token");
export const headers = {
    'Content-Type': 'application/json',
};

export const Header = {
    'Content-Type': 'application/json',
    'authorization': `${user_Token}`
};